import React, { useState } from 'react';
import { IGlobalMail } from '../../Interfaces/IGlobalMail';
import { Alert, Box, Button, Collapse, Grow, Typography } from '@mui/material';
import { DataGrid, GridColDef, deDE } from '@mui/x-data-grid';
import { GlobalMailEdit } from './GlobalMailEdit';
import { LoadingSpinner } from '../../core/LoadingSpinner';
import { useGetGlobalMails } from '../../hooks/reactQuerys/GlobalMailQueries';

const options: Intl.DateTimeFormatOptions = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

const columns: GridColDef[] = [
  { field: 'idGlobalMail', headerName: 'Nr.', width: 90 },
  {
    field: 'Send_at',
    headerName: 'Vom',
    width: 250,
    renderCell: params => (
      <>{new Date(params.row.Send_at).toLocaleString('de-DE', options)}</>
    ),
  },
  { field: 'Title', headerName: 'Bezeichnung', flex: 1 },
  { field: 'Correct', headerName: 'Erfolgreich', width: 90 },
  { field: 'Error', headerName: 'Fehlerhaft', width: 90 },
  { field: 'Total', headerName: 'Total', width: 90 },
];

export const GlobalMailOverview = () => {
  const { globalMails, isLoadingGlobalMails } = useGetGlobalMails();

  if (isLoadingGlobalMails) {
    return <LoadingSpinner />;
  }

  if (!globalMails) {
    return <Alert severity='error'>Zugriff verweigert</Alert>;
  }

  return <GlobalMail initialMails={globalMails} />;
};

type IProps = {
  initialMails: IGlobalMail[];
};

export const GlobalMail = ({ initialMails }: IProps) => {
  const [mails, setMails] = useState<IGlobalMail[]>(initialMails);
  const [idGlobalMail, setIdGlobalMail] = useState<number | null>(null);

  return (
    <>
      <Collapse in={idGlobalMail !== null}>
        <Box>
          {idGlobalMail !== null && (
            <GlobalMailEdit
              key={`idGlobalMail-${idGlobalMail}`}
              currentId={idGlobalMail}
              setCurrentId={setIdGlobalMail}
              currentArray={mails}
              setCurrentArray={setMails}
              setWasSaved={() => {}}
              setWasSavedSuccesfully={() => {}}
            />
          )}
        </Box>
      </Collapse>

      <Typography variant='h5' sx={{ mt: 5 }}>
        Globale E-Mail (an alle Mandaten mit Login)
        <Grow in={idGlobalMail === null}>
          <Button
            sx={{ float: 'right' }}
            variant='contained'
            onClick={() => setIdGlobalMail(-1)}
          >
            Neue E-Mail
          </Button>
        </Grow>
      </Typography>
      <Box sx={{ mt: 2 }} />

      <DataGrid
        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
        rows={mails}
        columns={columns}
        getRowId={row => row.idGlobalMail}
        onRowClick={params => setIdGlobalMail(Number(params.id))}
      />
    </>
  );
};
